import React from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";

import { usePopup, usePortal } from "hooks";
import { makeBEM } from "utils";

import { Card } from "../card";
import { ComponentSize } from "../types";

import "./index.scss";

export interface ModalProps {
  size?: ComponentSize;
  open?: boolean;
  onClose?: () => void;
}

const bem = makeBEM("modal");

export const Modal: React.FC<React.PropsWithChildren<ModalProps>> = ({ size = "md", open, onClose, children }) => {
  const portal = usePortal("modal-portal");
  usePopup(!!open);
  const { i18n } = useTranslation();

  return (
    <>
      {open &&
        ReactDOM.createPortal(
          <div className={bem(null, { open }, [size])} dir={i18n.dir()}>
            <div className={bem("overlay")} />
            <div className={bem("content")} onClick={() => onClose?.()}>
              <Card
                onClick={(e) => {
                  e.stopPropagation();
                }}
                className={bem("card")}
              >
                {children}
              </Card>
            </div>
          </div>,
          portal,
        )}
    </>
  );
};
